import axios from '@/api/axios';

const getSpecializations = (params) => axios.get('/directory/specializations', {params});

const getReallyAllSpecializations = () => axios.get('/directory/specializations/really_all');

const getSpecialization = (code) => axios.get(`/directory/specializations/${code}`);

const getAddresses = (query, count, from, to) =>
  axios.get(`/directory/addresses?query=${query}&count=${count}&from_bound=${from}&to_bound=${to}`);

const getOrganizations = (query, status = 'all') =>
  axios.get(`/directory/organizations?query=${query}&status=${status}`);

const getServices = () => axios.get('/directory/services');

const getSkills = (specId, typeId, blockId, zeroRegistry, testing360Id) =>
  axios.get('/directory/skills', {
    params: {
      specId,
      typeId,
      blockId,
      zero_registry: zeroRegistry,
      testing_360_id: testing360Id,
    },
  });

const getTestingIndicators = (reportName, testId) =>
  axios.get(`/directory/testing_indicators?report=${reportName}${testId ? `&test=${testId}` : ''}`);

const getTestingRoles = () => axios.get('/directory/testing_roles');

const getMaterialTypes = () => axios.get(`/directory/material_types`);

const getScales = (specCode) => axios.get(`/directory/specializations/${specCode}/scales`);

const getTargetTypes = () => axios.get('/directory/target_types');

export default {
  getSpecializations,
  getReallyAllSpecializations,
  getSpecialization,
  getAddresses,
  getOrganizations,
  getServices,
  getSkills,
  getTestingIndicators,
  getTestingRoles,
  getMaterialTypes,
  getScales,
  getTargetTypes,
};
